import { Radio } from "@mui/material";
import { styled } from "@mui/material/styles";

import { profileThemeColors } from "../../config/profileThemeColors";

export const styles = {
  formControl: {
    padding: "28px 20px",
    border: "1px solid black",
    borderRadius: "20px",
  },
  title: { fontSize: "16px", lineHeight: "20px", fontWeight: 500 },
  radioGroup: { gap: 2 },
  formControlLabel: {
    margin: "unset",
  },
};

export const ColorRadio = styled(Radio)(({ paint, selected }) => ({
  "& .MuiSvgIcon-root": {
    display: "none",
  },
  width: 28,
  height: 28,
  borderRadius: "50%",
  backgroundColor: profileThemeColors[paint]?.primary || "#fff",
  margin: "0px",
  transition: "transform 0.3s",
  position: "relative",
  "&:hover": {
    backgroundColor: profileThemeColors[paint]?.primary,
    transform: "scale(1.2)",
  },
  "&.Mui-checked": {
    transform: "scale(1.5)",
  },
  "&::after": selected
    ? {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        width: "16px",
        height: "16px",
        transform: "translate(-50%, -50%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' stroke='${encodeURIComponent(
          profileThemeColors[paint]?.secondary
        )}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      }
    : {},
}));
